import axios from "axios"

export const verifyUser = async (userId: string, verified: number) => {
  try {
    await axios.post(`users/${userId}/verify`, { verified })
  } catch (err) {
    console.log("verification err", err)
  }
  return null
}
